/**
 * Stable id → HSL color mapping for project bars in Resource Histogram.
 * Same id always yields the same hue across sessions, so a project keeps
 * its colour as the user navigates / reloads.
 */

// Golden-angle conjugate — distributes hues so adjacent ids look distinct.
const PHI = 0.618033988749895;

export function colorForProject(id) {
  // Multiply by golden ratio mod 1 to spread hues; saturation/lightness
  // tuned for the dark theme (saturated but not eye-burning).
  const hue = Math.floor(((Number(id) * PHI) % 1) * 360);
  return `hsl(${hue}, 60%, 55%)`;
}

export const FEVER_COLORS = {
  green:  '#3fb950',
  yellow: '#d29922',
  red:    '#f85149',
};
export const FEVER_BG = {
  green:  'rgba(63,  185, 80,  0.18)',
  yellow: 'rgba(210, 153, 34,  0.18)',
  red:    'rgba(248, 81,  73,  0.18)',
};
